import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(LoadingButton)``;
